





















/* eslint-disable @typescript-eslint/camelcase */
import { Component, Prop, Vue } from 'vue-property-decorator'
import AppFormTable from '@core/components/AppFormTable.vue'
import { ClientPolicyDto } from '../../api'
import { TableFormStructure } from '@master/model/structure/FormStructure'
import { UIService } from '@core/services/UIService'
import { inject } from 'inversify-props'
import { SharedVariable } from '@core/model/SharedVariable'
import { options } from '@core/model/UIOptions'

@Component({
  components: {
    AppFormTable
  }
})
export default class RiderSection extends Vue {
  @Prop({ default: () => [] }) private subPolicies: ClientPolicyDto[]
  @Prop({ default: {} }) private policy: ClientPolicyDto
  @Prop({ default: () => [] }) private productOptions: options[]

  uiService: UIService

  @inject()
  private sharedVariable: SharedVariable

  get isDisabled () {
    return true
  }

  get isOpsStaff () {
    // @TODO: To remove anything related to store
    return this.$store.getters.currentUser.systemrole !== 'ops-staff'
  }

  get tableStructure (): TableFormStructure<ClientPolicyDto> {
    return [
      {
        label: 'Rider Name',
        key: 'productOid',
        type: 'dropdown',
        options: this.productOptions,
        disabled: this.isDisabled
      },
      {
        label: 'Benefit Amount ($)',
        type: 'currency',
        model: {
          get: (idx) => this.subPolicies[idx].productMetadata?.sumAssured,
          set: (idx, val) => {
            // intentionally left blank
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Prem ($)',
        type: 'currency',
        model: {
          get: (idx) => this.subPolicies[idx].productMetadata?.premiumAmount,
          set: (idx, val) => {
            // intentionally left blank
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Effective Date',
        type: 'date',
        key: 'startDate',
        disabled: this.isDisabled
      },
      {
        label: 'Expiry Date',
        type: 'date',
        key: 'endDate',
        disabled: this.isDisabled
      }
    ]
  }

  get lifeInsuranceFields () {
    return this.policy.type === 'lifeinsurance'
  }

  addRider () {
    this.$emit('life-insurance-policy-new-sub')
  }

  async removeRider (idx: number) {
    const isConfirm = await this.uiService.confirm.show({
      type: 'success',
      message: 'Are you sure to delete the selected policy?'
    }) as boolean

    if (isConfirm) {
      this.$emit('life-insurance-policy-remove-sub', this.subPolicies[idx].oid)
    }
  }

  policyClicked (index: number) {
    this.$emit('life-insurance-policy-clicked-sub', this.subPolicies[index])
  }

  mounted () {
    this.uiService = this.sharedVariable.uiService
  }
}
